import React from 'react';
import { useScreenInit } from '../useScreenInit.js';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { FIRM } from '../lib/constants';
import { Container } from '../components/ui/Container';
import { EnquiryForm } from '../components/EnquiryForm';
const assurances = ['We respond within one business day', 'Your enquiry goes to the most appropriate team', 'No obligation to explain everything perfectly', 'Confidential from the first contact'];
export function Enquiry() {
  useScreenInit();
  return <div className="w-full bg-cream" data-id="element-476">
      <section className="bg-navy py-12 text-cream lg:py-16" data-id="element-477">
        <Container data-id="element-478">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-brass-light" data-id="element-479">
            Contact us
          </p>
          <h1 className="max-w-3xl font-serif text-4xl font-500 leading-tight tracking-tight sm:text-5xl" data-id="element-480">
            Not sure what to do next? Start with a confidential enquiry.
          </h1>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-cream/70" data-id="element-481">
            Tell us what has happened and we'll help you understand the right
            next step.
          </p>
        </Container>
      </section>

      <section className="py-12 lg:py-16" data-id="element-482">
        <Container className="grid grid-cols-1 gap-10 lg:grid-cols-12" data-id="element-483">
          {/* form */}
          <div className="lg:col-span-7" data-id="element-484">
            <div className="rounded-2xl border border-navy/10 bg-white p-6 shadow-card sm:p-8" data-id="element-485">
              <h2 className="font-serif text-2xl text-navy" data-id="element-486">Send an enquiry</h2>
              <p className="mt-1 mb-6 text-sm text-ink/60" data-id="element-487">
                A short summary is all we need to get started.
              </p>
              <EnquiryForm data-id="element-488" />
            </div>
          </div>

          {/* sidebar */}
          <aside className="lg:col-span-5" data-id="element-489">
            <div className="rounded-2xl bg-navy p-6 text-cream sm:p-7" data-id="element-490">
              <h2 className="font-serif text-xl text-cream" data-id="element-491">Prefer to talk?</h2>
              <p className="mt-1 text-sm text-cream/70" data-id="element-492">
                For urgent matters, calling is fastest.
              </p>
              <a href={FIRM.phoneHref} className="mt-4 flex items-center justify-center gap-2 rounded-lg bg-brass px-4 py-3.5 font-semibold text-white transition-colors hover:bg-brass-dark" data-id="element-493">
                <PhoneIcon className="h-5 w-5" data-id="element-494" /> Call {FIRM.phoneDisplay}
              </a>

              <ul className="mt-6 space-y-3 text-sm text-cream/80" data-id="element-495">
                <li className="flex items-start gap-3" data-id="element-496">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brass-light" data-id="element-497" />
                  <span data-id="element-498">
                    {FIRM.addressLine1}
                    <br data-id="element-499" />
                    {FIRM.addressLine2}
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-500">
                  <MailIcon className="h-4 w-4 shrink-0 text-brass-light" data-id="element-501" />
                  <a href={FIRM.emailHref} className="hover:text-brass-light" data-id="element-502">
                    {FIRM.email}
                  </a>
                </li>
                <li className="flex items-center gap-3" data-id="element-503">
                  <ClockIcon className="h-4 w-4 shrink-0 text-brass-light" data-id="element-504" />
                  <span data-id="element-505">Mon–Fri, 8:30am–5:00pm AWST</span>
                </li>
              </ul>
            </div>

            <div className="mt-5 rounded-2xl border border-navy/10 bg-white p-6" data-id="element-506">
              <div className="flex items-center gap-2" data-id="element-507">
                <ShieldCheckIcon className="h-5 w-5 text-sage" data-id="element-508" />
                <h3 className="font-serif text-lg text-navy" data-id="element-509">
                  What happens next
                </h3>
              </div>
              <ul className="mt-4 space-y-2.5" data-id="element-510">
                {assurances.map(a => <li key={a} className="flex items-start gap-2.5 text-sm text-ink/70" data-id="element-511">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brass-dark" data-id="element-512" />
                    {a}
                  </li>)}
              </ul>
              <p className="mt-4 border-t border-navy/10 pt-4 text-xs leading-relaxed text-ink/45" data-id="element-513">
                Contacting us does not create a lawyer–client relationship.
                Please don't send confidential or time-critical information you
                need acted on immediately — call us instead.
              </p>
            </div>
          </aside>
        </Container>
      </section>
    </div>;
}